import classNames from 'classnames';
import React from 'react';

import Image from '@Components/Image';
import Row from '@Components/layout/Row';
import { PaperBodySpacing } from '@Components/PaperBody';
import PageSection from '@Components/sections/PageSection';
import { useTranslations } from '@Hooks/useTranslations';
import AgrotekaLogo from '@Images/partners/agrotekaLogo.png';
import HegvitaLogo from '@Images/partners/hegvitaLogo.png';
import KdLogo from '@Images/partners/kdLogo.png';
import RovaltraLogo from '@Images/partners/rovaltraLogo.png';

import styles from './PartnersSection.module.scss';

const PartnersSection = () => {
  const t = useTranslations();

  return (
    <PageSection title={t('msg_landing_partners_section_title')} spacing={PaperBodySpacing.s}>
      <Row constant className={styles.imageContainer}>
        <Image src={RovaltraLogo} alt="RovaltraLogo" className={styles.image} />
        <Image src={AgrotekaLogo} alt="AgrotekaLogo" className={classNames(styles.image, styles.agrotekaLogo)} />
        <Image src={HegvitaLogo} alt="HegvitaLogo" className={styles.image} />
        <Image src={KdLogo} alt="KdLogo" className={styles.image} />
      </Row>
    </PageSection>
  );
};

export default PartnersSection;
